module.exports = __webpack_public_path__ + "static/media/mayur.84798749.png";